module.exports = __webpack_public_path__ + "img/tjfoot5.fad2cb95.jpg";